module.exports = "/components/components/previewBannerComponent-6dd857.html";